// Simple prev/next controls for the native scroll-snap [data-story-scroll] carousel.
(function () {
  function init() {
    document.querySelectorAll('[data-story-scroll]').forEach(function (scroller) {
      var wrap = scroller.closest('section');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-story-prev]');
      var next = wrap.querySelector('[data-story-next]');
      var slide = scroller.querySelector('.story-slide');
      var step = function () {
        return slide ? slide.getBoundingClientRect().width + 24 : scroller.clientWidth * 0.9;
      };
      if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
